import React, {useState} from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';

export default function Gallery({
    list
}) {

    const [openImage, setOpenImage] = useState(undefined)
    const [startX, setStartX] = useState(undefined)
    const [startY, setStartY] = useState(undefined)

    const onMouseDownHandler = (e) => {
        setStartX(e.screenX);
        setStartY(e.screenY);
        e.preventDefault()
    };

    const handleOnClick = (e, item) => {
        e.stopPropagation()
        if (startX === e.screenX && startY === e.screenY) {
            setOpenImage(item)
        } else {
            e.preventDefault()
        }
    }

    return (
        <div className='w-250 min-w-250 md:w-full pb-6'>
            <Swiper
                spaceBetween={20}
                slidesPerView={3}
            >
                {list?.map((item, index) => {
                    return (
                        <SwiperSlide key={index}>
                            <div
                                className='relative w-250 max-w-250 aspect-4/3 md:w-auto md:max-w-none pr-2'
                                onMouseDown={(event) => onMouseDownHandler(event)}
                                onClick={(event) => handleOnClick(event, item)}
                            >
                                <img
                                    className='w-full h-full aspect-4/3 rounded-xl overflow-hidden'
                                    src={item}
                                />
                            </div>
                        </SwiperSlide>
                    )
                })}
            </Swiper>
            
            {openImage &&
                <div className='fixed top-0 left-0 w-full h-full bg-white bg-opacity-90 z-1000 flex items-center justify-center' onClick={() => setOpenImage(undefined)}>
                    <img
                        src={openImage}
                        className='max-w-90% max-h-90% rounded-lg'
                    />
                </div>
            }
        </div>
    )
}
